export default {
  subtitle: 'Enviamos os eventos selecionados para os seus endpoints por POST, assinados com o segredo do endpoint.',
  regenerate_confirm: 'Gerar um novo segredo de assinatura? O segredo atual deixa de funcionar de imediato.',
  delete_confirm: 'Eliminar este endpoint? Deixará de receber eventos.',
  consecutive_failures: '{{count}} falhas consecutivas',
  columns: {
    url: 'Endpoint',
    events: 'Eventos',
    status: 'Estado',
    secret: 'Segredo',
  },
  statuses: {
    active: 'Ativo',
    disabled: 'Desativado',
    auto_disabled: 'Desativado automaticamente',
  },
  buttons: {
    create: 'Adicionar endpoint',
    edit: 'Editar',
    regenerate_secret: 'Novo segredo',
    delete: 'Eliminar',
  },
  toasts: {
    load_error: 'Não foi possível carregar os endpoints de webhook.',
    error: 'Ocorreu um erro. Tente novamente.',
    deleted: 'Endpoint eliminado.',
  },
};
